import { render, staticRenderFns } from "./AccountStep.vue?vue&type=template&id=5940e482&"
import script from "./AccountStep.vue?vue&type=script&lang=js&"
export * from "./AccountStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports